<template>
  <div class="pt-1 container-fluid">
    <div class="row">
        <div class="d-flex">
          <h6 class="border-bottom w-auto" style="border-bottom-color: gray !important;">
          Onu Down Scanner
        </h6>
        
        </div> 
        <div class="d-flex">
          <button 
          class="btn btn-success btn-sm" 
          @click="toggleAutoScan"
          :class="{ 'btn-danger': isAutoScanning }"
        >
          {{ isAutoScanning ? 'Stop Auto' : 'Auto' }}
        </button>
        <input 
          type="text" 
          v-model="searchOlts" 
          class="form-control invoice flex-grow-1 text-white mx-2" 
          placeholder="Search olt..."
          style="max-width: 300px;"
        />
        </div>
      <olt-selector 
            :olts="displayOlts" 
            :loading="loading"
            :currentLoadingOlt="currentLoadingOlt"
            :currentOltId="currentOltId"
            @olt-selected="handleOltSelected"
          />
    </div>
    <div class="row dark-modeon" v-if="searchQuery || mappedTableData.length > 0">
      
          
      <div >
        <div class="d-flex justify-content-between mt-3">
          <h6>Total Items <span class="badge">{{ filteredData.length }}</span></h6>
          <input 
            type="text" 
            v-model="searchQuery" 
            class="form-control invoice flex-grow-1 mt-1 mx-2" 
            placeholder="Search form table..."
            style="max-width: 300px;"
          />
        </div>
        <div class="olt-container px-3">
          
          <!-- Dynamic table selection based on oltType -->
          <component
            :is="currentTableComponent"
            :loading="loading"
            :filteredData="mappedTableData"
            :sortKey="sortKey"
            :sortOrder="sortOrder"
            @sort="sort"
            :key="componentKey" 
            :loadingPPPOE="loadingPPPOE"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OltSelector from '../components/onu-down-scanner/OltSelector.vue';
import BdcomGponTable from '../components/onu-down-scanner/BdcomGponTable.vue';
import BdcomEponTable from '../components/onu-down-scanner/BdcomEponTable.vue';
import VsolEponTable from '../components/onu-down-scanner/VsolEponTable.vue';
import VsolGponTable from '../components/onu-down-scanner/VsolGponTable.vue';
import AviesEponTable from '../components/onu-down-scanner/AviesEponTable.vue';
import CdataV12EponTable from '../components/onu-down-scanner/CdataV12EponTable.vue';
import CloudeEponTable from '../components/onu-down-scanner/CloudeEponTable.vue';
import { useSearchApi } from "../services/search.service";
import showSwal from "../mixins/showSwal.js";

export default {
  name: "OnuDownScanner",
  components: {
    OltSelector,
    BdcomGponTable,
    BdcomEponTable,
    VsolEponTable,
    VsolGponTable,
    AviesEponTable,
    CdataV12EponTable,
    CloudeEponTable
  },
  data() {
    return {
      sortKey: "",
      sortOrder: "asc",
      data: [],
      losData: [],
      filteredData: [],
      searchQuery: "",
      searchOlts: "",
      loading: false,
      loadingPPPOE: false,
      currentLoadingOlt: null,
      currentOltId: null,
      currentOltType: null,
      user: JSON.parse(localStorage.getItem("user_data")),
      componentKey: 0,
      isAutoScanning: false,
      oltDataCache: {},
      allOltData: [],
      displayOlts: [],
    };
  },
  computed: {
    currentTableComponent() {
      if (!this.currentOltType) return 'div';
      
      switch(this.currentOltType) {
        case 'BDCOM-GPON': return 'BdcomGponTable';
        case 'BDCOM-EPON': return 'BdcomEponTable';
        case 'VSOL-EPON': return 'VsolEponTable';
        case 'VSOL-GPON': return 'VsolGponTable';
        case 'AVIES-EPON': return 'AviesEponTable';
        case 'CDATA-V1.2-EPON': return 'CdataV12EponTable';
        case 'CDATA-CLOUDE-EPON-EPON': return 'CloudeEponTable';
        default: return 'div';
      }
    },
    mappedTableData() {
      // Apply search filter to the current data view
      const dataToMap = this.filteredData.filter(item => {
        const query = this.searchQuery.toLowerCase();
        return Object.values(item).some(value => 
          value && value.toString().toLowerCase().includes(query)
        );
      });

      // During auto scan, only show data for the current OLT type
      if (this.isAutoScanning && this.currentOltType) {
        return dataToMap.filter(item => {
          const itemOltType = this.getOltTypeForItem(item);
          return itemOltType === this.currentOltType;
        });
      }

      // For non-auto scan mode, show all data
      return dataToMap;
    }
  },
  watch: {
    searchOlts: {
      immediate: true,
      handler(newValue) {
        if (!this.data.olts) return;
        
        if (!newValue || newValue.trim() === '') {
          this.displayOlts = this.data.olts;
          return;
        }
        
        const searchTerm = newValue.toLowerCase().trim();
        this.displayOlts = this.data.olts.map(brand => {
          const filteredBrand = { ...brand };
          
          if (brand.GPON) {
            filteredBrand.GPON = brand.GPON.filter(olt => 
              olt.olt_name.toLowerCase().includes(searchTerm) || 
              olt.oltid.toString().includes(searchTerm)
            );
          }
          
          if (brand.EPON) {
            filteredBrand.EPON = brand.EPON.filter(olt => 
              olt.olt_name.toLowerCase().includes(searchTerm) || 
              olt.oltid.toString().includes(searchTerm)
            );
          }
          
          return filteredBrand;
        }).filter(brand => 
          (brand.GPON && brand.GPON.length > 0) || 
          (brand.EPON && brand.EPON.length > 0)
        );
      }
    }
  },
  async mounted() {
    await this.loadInitialData();
  },
  methods: {
    async loadInitialData() {
      this.data = await useSearchApi().getOltBnd(this.user.fendy_user_id);
      this.displayOlts = this.data.olts;
    },
    getOltTypeForItem(item) {
      const oltInfo = this.data.olts.find(brand => 
        (brand.GPON && brand.GPON.some(olt => olt.oltid === item.olt_id)) ||
        (brand.EPON && brand.EPON.some(olt => olt.oltid === item.olt_id))
      );
      
      if (oltInfo) {
        const isGpon = oltInfo.GPON?.some(olt => olt.oltid === item.olt_id);
        return `${oltInfo.olt_brand_name}-${isGpon ? 'GPON' : 'EPON'}`;
      }
      return null;
    },
    async toggleAutoScan() {
      if (this.isAutoScanning) {
        this.isAutoScanning = false;
        this.currentOltId = null;
        this.currentOltType = null;
        this.componentKey += 1;
        // Show all accumulated data after auto scan completes
        this.filteredData = [...this.allOltData];
        return;
      }

      this.isAutoScanning = true;
      this.allOltData = [];
      this.filteredData = [];
      this.oltDataCache = {};
      this.searchQuery = '';
      this.currentOltId = null;
      this.currentOltType = null;
      this.componentKey += 1;

      const allOltIds = [];
      for (const brand of this.data.olts) {
        if (brand.GPON) {
          allOltIds.push(...brand.GPON.map(olt => olt.oltid));
        }
        if (brand.EPON) {
          allOltIds.push(...brand.EPON.map(olt => olt.oltid));
        }
      }

      for (const oltId of allOltIds) {
        if (!this.isAutoScanning) break;
        
        try {
          this.currentLoadingOlt = oltId;

          let oltInfo = null;
          let oltType = null;
          for (const brand of this.data.olts) {
            if (brand.GPON) {
              const found = brand.GPON.find(olt => olt.oltid === oltId);
              if (found) { oltInfo = found; oltType = 'GPON'; break; }
            }
            if (brand.EPON) {
              const found = brand.EPON.find(olt => olt.oltid === oltId);
              if (found) { oltInfo = found; oltType = 'EPON'; break; }
            }
          }

          if (oltInfo) {
            const brandName = oltInfo.olt_brand_name || this.data.olts.find(b => 
              b.GPON?.some(o => o.oltid === oltId) || 
              b.EPON?.some(o => o.oltid === oltId)
            )?.olt_brand_name;
            
            // Set the current OLT type and ID for proper table rendering
            this.currentOltType = `${brandName}-${oltType}`;
            this.currentOltId = oltId;
            this.componentKey += 1; // Force table re-render for new OLT type

            // Fetch data for the current OLT
            await this.getLosFinderData(oltId, true);

            // After fetching data, update the display to show only current OLT's data
            const currentOltData = this.allOltData.filter(item => item.olt_id === oltId);
            this.filteredData = currentOltData;

            // Wait for PPPOE IDs to be fetched before moving to next OLT
            await this.fetchPPPOEIds(oltId, true);
          }
          
        } catch (error) {
          console.error(`Error scanning OLT ${oltId}:`, error);
        } finally {
          if (this.currentLoadingOlt === oltId) {
            this.currentLoadingOlt = null;
          }
        }
        await new Promise(resolve => setTimeout(resolve, 2000)); // 2 second delay
      }

      this.isAutoScanning = false;
      this.currentOltId = null;

      // Find the first OLT type present in allOltData
      if (this.allOltData.length > 0) {
        const firstItem = this.allOltData[0];
        this.currentOltType = this.getOltTypeForItem(firstItem);
        // Only show ONUs for the first OLT type
        this.filteredData = this.allOltData.filter(
          item => this.getOltTypeForItem(item) === this.currentOltType
        );
      } else {
        this.currentOltType = null;
        this.filteredData = [];
      }

      this.componentKey += 1;
      this.oltDataCache['all'] = { data: this.allOltData, oltType: 'all' };
    },
    handleOltSelected(id) {
      // Reset state before loading new data for single OLT selection (if not auto scanning)
      if (!this.isAutoScanning) {
         this.filteredData = [];
         this.losData = []; // Clear losData as well for a fresh start
         this.sortKey = "";
         this.sortOrder = "asc";
         this.searchQuery = ''; // Clear search when selecting new OLT
         this.currentOltType = null; // Clear type before finding the new one
         this.currentOltId = null; // Clear ID before finding the new one
         this.componentKey += 1; // Force table re-render
      }

      // Find the OLT type for the selected OLT from the original data
      let selectedOltType = null;
      const oltInfo = this.data.olts.find(brand => 
        (brand.GPON && brand.GPON.some(olt => olt.oltid === id)) ||
        (brand.EPON && brand.EPON.some(olt => olt.oltid === id))
      );
      if (oltInfo) {
        const isGpon = oltInfo.GPON?.some(olt => olt.oltid === id);
        selectedOltType = `${oltInfo.olt_brand_name}-${isGpon ? 'GPON' : 'EPON'}`;
      }

      // If auto scanning, filter the current allOltData for the selected OLT and update display state
      if (this.isAutoScanning) {
         if (selectedOltType) {
           this.currentOltId = id;
           this.currentOltType = selectedOltType; // Set OLT type for selected OLT
           this.componentKey += 1; // Force table re-render

           // Filter the accumulated data (allOltData) to show only the selected OLT's data
           // Use allOltData as it contains the most complete data including updated PPPOE IDs from auto-scan
           this.filteredData = this.allOltData.filter(item => item.olt_id === id);
         }
         return; // Exit if in auto scan mode
      }

      // If NOT auto scanning, handle single OLT selection (check cache or fetch fresh data)

      // Check if we have cached data for this specific OLT
      if (this.oltDataCache[id]) {
        this.filteredData = this.oltDataCache[id].data;
        this.currentOltId = id;
        this.currentOltType = this.oltDataCache[id].oltType;
        this.componentKey += 1; // Force table re-render after loading from cache
        // Explicitly fetch PPPOE IDs in the background in case cached data was incomplete
        this.fetchPPPOEIds(id, false); 
        return;
      }
      
      // If we have all data from a previous auto scan, filter it for this OLT when NOT auto scanning
      // This case is for viewing accumulated auto-scan data after auto-scan is finished.
      // Check allOltData if cache is empty for this ID.
      if (this.allOltData.length > 0) {
         const oltData = this.allOltData.filter(item => item.olt_id === id);
         if (oltData.length > 0) {
           this.filteredData = oltData;
           this.currentOltId = id;
           // Find OLT type from the original data structure (data.olts)
           const oltInfoFromData = this.data.olts.find(brand => 
             (brand.GPON && brand.GPON.some(olt => olt.oltid === id)) ||
             (brand.EPON && brand.EPON.some(olt => olt.oltid === id))
           );
           if (oltInfoFromData) {
             const isGpon = oltInfoFromData.GPON?.some(olt => olt.oltid === id);
             this.currentOltType = `${oltInfoFromData.olt_brand_name}-${isGpon ? 'GPON' : 'EPON'}`;
           }
           this.componentKey += 1; // Force table re-render
           // No need to fetch PPPOE IDs here, allOltData should have them if auto-scan completed
           return;
         }
       }
      
      // If no cached data and no auto-scan data for this ID, fetch new data (when NOT auto scanning)
      // This handles the initial selection of an OLT or selecting an OLT not covered by previous auto-scan.
      this.getLosFinderData(id);
    },
    resetState() {
      this.filteredData = [];
      this.losData = [];
      this.sortKey = "";
      this.sortOrder = "asc";
      this.currentOltType = null;
      this.componentKey += 1;
      this.searchQuery = '';
    },
    async getLosFinderData(id, isAutoScan = false) {
      try {
        this.loading = true;
        this.currentLoadingOlt = id;
        this.currentOltId = id;

        // Find OLT details - KEEP EXACTLY THE SAME
        let oltInfo = null;
        let oltType = null;
        
        for (const brand of this.data.olts) {
          if (brand.GPON) {
            const found = brand.GPON.find(olt => olt.oltid === id);
            if (found) {
              oltInfo = found;
              oltType = 'GPON';
              break;
            }
          }
          if (brand.EPON) {
            const found = brand.EPON.find(olt => olt.oltid === id);
            if (found) {
              oltInfo = found;
              oltType = 'EPON';
              break;
            }
          }
        }

        if (!oltInfo) {
          throw new Error('OLT not found');
        }

        const brandName = oltInfo.olt_brand_name || this.data.olts.find(b => 
          b.GPON?.some(o => o.oltid === id) || 
          b.EPON?.some(o => o.oltid === id)
        )?.olt_brand_name;

        this.currentOltType = `${brandName}-${oltType}`;

        let response;
        switch (this.currentOltType) {
          case 'BDCOM-GPON':
            response = await useSearchApi().getBdcomGponLosFinder(id);
            this.losData = response.inactive_onus || [];
            break;
          case 'BDCOM-EPON':
            response = await useSearchApi().getBdcomEponLosFinder(id);
            this.losData = response.inactive_onus || [];
            break;
          case 'VSOL-EPON':
            response = await useSearchApi().getVsolEponLosFinder(id);
            this.losData = response.data || [];
            break;
          case 'VSOL-GPON':
            response = await useSearchApi().getVsolGponLosFinder(id);
            this.losData = response.onus || [];
            break;
          case 'AVIES-EPON':
            response = await useSearchApi().getAviesEponLosFinder(id);
            this.losData = response.data || [];
            break;
          case 'CDATA-V1.2-EPON':
            response = await useSearchApi().getRealtimeValueAll(id);
            this.losData = response.items || [];
            break;
          case 'CDATA-CLOUDE-EPON-EPON':  
            response = await useSearchApi().getCloudEdponDown(id);
            this.losData = response.data || [];
            break;
          default:
            throw new Error(`Unsupported OLT type: ${this.currentOltType}`);
        }

        if(!this.losData || this.losData.length === 0){
          showSwal.methods.showSwal({
              type: "error",
                message: "Inactive onu not found",
            });
        }

        // First show the data without PPPOE_IDs - KEEP EXACTLY THE SAME
        const initialOltData = this.losData.map(onu => ({
          ...onu,
          PPPOE_ID: 'Loading...',
          olt_id: id
        }));

        // Cache the initial data (without PPPOE_IDs) if not auto scanning - KEEP EXACTLY THE SAME
        if (!isAutoScan) {
          this.filteredData = initialOltData;
          // Only call fetchPPPOEIds for manual scan
          this.fetchPPPOEIds(id, isAutoScan);
        } else {
          // In auto scan, append to filteredData immediately to show progressive results
          this.filteredData = [...this.filteredData, ...initialOltData];
          // Also add to allOltData to keep a complete record for final state/caching
          this.allOltData = [...this.allOltData, ...initialOltData];
          // DO NOT call fetchPPPOEIds here for auto scan, it will be called in the scan loop
        }

      } catch (error) {
        console.error('Error fetching LOS data:', error);
        this.filteredData = [];
      } finally {
        this.loading = false;
        this.currentLoadingOlt = null;
      }
    },
    async fetchPPPOEIds(oltid, isAutoScan = false) {
  // Only show loading state if not in auto scan mode, to avoid constant flickering
  if (!isAutoScan) {
    this.loadingPPPOE = true;
  }
  try {
    const updatedDataPromises = this.losData.map(async (onu) => {
      try {
        // Use the correct interface name for each OLT type
        let interfaceName = onu.onu_interface || onu.interface_name || onu.port || '';
        console.log('Fetching PPPOE for', oltid, interfaceName, onu);
        
        if (!interfaceName) {
          console.warn('No interface name found for ONU:', onu);
          return {
            ...onu,
            PPPOE_ID: 'N/A',
            olt_id: oltid,
          };
        }

        const onuDetails = await useSearchApi().geOnuLoss(oltid, interfaceName);
        console.log('PPPOE API response for port', interfaceName, ':', onuDetails);
        
        return {
          ...onu,
          PPPOE_ID: onuDetails.length > 0 ? onuDetails[0].PPPOE_ID : 'N/A',
          olt_id: oltid,
        };
      } catch (error) {
        console.error('PPPOE fetch error:', error, oltid, onu);
        return {
          ...onu,
          PPPOE_ID: 'Error',
          olt_id: oltid,
        };
      }
    });

    const updatedData = await Promise.all(updatedDataPromises);

    // Update the data in filteredData and allOltData with fetched PPPOE IDs
    const updatedDataMap = new Map();
    updatedData.forEach(item => {
      // Create a unique key using olt_id and port/interface
      const key = `${item.olt_id}-${item.port || item.interface_name || item.onu_interface || item.reg_port_or_onu_id}`;
      updatedDataMap.set(key, item);
    });

    // Update filteredData: find items belonging to this oltid and update their PPPOE_ID
    this.filteredData = this.filteredData.map(item => {
      const key = `${item.olt_id}-${item.port || item.interface_name || item.onu_interface || item.reg_port_or_onu_id}`;
      const updatedItem = updatedDataMap.get(key);
      if (item.olt_id === oltid && updatedItem && updatedItem.PPPOE_ID !== 'Loading...') {
        return { ...item, PPPOE_ID: updatedItem.PPPOE_ID };
      }
      return item;
    });

    // Update allOltData: find items belonging to this oltid and update their PPPOE_ID
    this.allOltData = this.allOltData.map(item => {
      const key = `${item.olt_id}-${item.port || item.interface_name || item.onu_interface || item.reg_port_or_onu_id}`;
      const updatedItem = updatedDataMap.get(key);
      if (item.olt_id === oltid && updatedItem && updatedItem.PPPOE_ID !== 'Loading...') {
        return { ...item, PPPOE_ID: updatedItem.PPPOE_ID };
      }
      return item;
    });

    // If in auto scan mode, force table re-render after PPPOE IDs are fetched
    if (isAutoScan) {
      this.componentKey += 1;
      // Cache the updated data for this OLT
      this.oltDataCache[oltid] = { 
        data: this.filteredData.filter(item => item.olt_id === oltid), 
        oltType: this.currentOltType 
      };
    }

  } catch (error) {
    console.error('Error fetching PPPOE IDs:', error);
  } finally {
    if (!isAutoScan) {
      this.loadingPPPOE = false;
      this.oltDataCache[oltid] = { data: this.filteredData, oltType: this.currentOltType };
    }
  }
},
    sort(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }

      this.filteredData.sort((a, b) => {
        const valueA = a[key] ? a[key].toString().toLowerCase() : "";
        const valueB = b[key] ? b[key].toString().toLowerCase() : "";
        const comparison = valueA.localeCompare(valueB);
        return this.sortOrder === "asc" ? comparison : -comparison;
      });
    }
  }
};
</script>
